import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { signOut } from "../firebase";
import { useUserProvider } from "../context/UserProvider";

import { ColorModeContext } from "../context/ColorModeProvider";

import { IconButton, Menu, Tooltip, MenuItem, Avatar } from "@mui/material";

export default function AvatarMenu({ displayName, photoURL }) {
  const { theme } = useContext(ColorModeContext);

  const { user } = useUserProvider();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  return (
    <>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          {photoURL ? (
            <Avatar
              style={{
                width: "30px",
                height: "30px",
              }}
            >
              <img src={photoURL} width="30px" alt={displayName} />
            </Avatar>
          ) : (
            <Avatar alt="Remy Sharp" src={photoURL} />
          )}
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {!user && (
          <Link to="/login" style={{ textDecoration: "none" }}>
            <MenuItem
              style={{
                color: theme.palette.mode === "dark" ? "#edf2f7" : "#121828",
              }}
              onClick={handleCloseUserMenu}
            >
              Login
            </MenuItem>
          </Link>
        )}

        {user && (
          <Link
            onClick={handleCloseUserMenu}
            to="/user-profile"
            style={{ textDecoration: "none" }}
          >
            <MenuItem
              style={{
                color: theme.palette.mode === "dark" ? "#edf2f7" : "#121828",
              }}
              onClick={handleCloseUserMenu}
            >
              Profile
            </MenuItem>
          </Link>
        )}
        {user && (
          <Link
            onClick={async (e) => {
              e.preventDefault();
              await signOut();
            }}
            to="/"
            style={{ textDecoration: "none" }}
            textAlign="center"
          >
            <MenuItem
              style={{
                color: theme.palette.mode === "dark" ? "#edf2f7" : "#121828",
              }}
              onClick={handleCloseUserMenu}
            >
              Logout
            </MenuItem>
          </Link>
        )}
        {/* {user && (
                <Link
                  to="/logout"
                  name="Logout"
                  onClick={async (e) => {
                    e.preventDefault();
                    await logout();
                  }}
                />
              )} */}
      </Menu>
    </>
  );
}
